import {
	ReactElement,
	useEffect,
	useMemo
} from "react";
import {
	DateFormat,
	DisplayWithExpiration,
	formatDateWithExpiration
} from "client_legacy/ndaw/dateFormatting";
import { useForceRerender } from "client/Hooks";
import { hasImplicitDependencyOn } from "client/Misc/reactUtils";
import { TimeZone } from "client/DateAndTime/timezones";

export type DateStringProps = {
	value: Date | string;
	format: DateFormat;
	timezone: TimeZone;
};

export const DateString = (props: DateStringProps): ReactElement => {
	const {
		value,
		format,
		timezone
	} = props;

	const display: string = useDateString(
		value,
		format,
		timezone
	);

	return (
		<>
			{ display }
		</>
	);
};
DateString.displayName = "DateString";

export function useDateString(
	value: Date | string,
	format: DateFormat,
	timezone: TimeZone
): string {
	const [rerender, version] = useForceRerender();

	const { display, expiresAfterMs } = useMemo(
		(): DisplayWithExpiration => {
			hasImplicitDependencyOn(version);

			return formatDateWithExpiration(
				value,
				format,
				timezone
			);
		},
		[
			format,
			value,
			version,
			timezone
		]
	);

	useEffect(
		(): (() => void) => {
			const timeoutHandle: SetTimeoutHandle = setTimeout(rerender, expiresAfterMs);
			return (): void => clearTimeout(timeoutHandle);
		},
		[expiresAfterMs, rerender]
	);

	return display;
}